import { render, staticRenderFns } from "./SharingInfo.vue?vue&type=template&id=623fac9e&scoped=true&"
import script from "./SharingInfo.vue?vue&type=script&lang=js&"
export * from "./SharingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623fac9e",
  null
  
)

export default component.exports